import { useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const Reveal = ({
  children,
  className = '',
  delay = 0,
  duration = 0.85,
  y = 36,
  x = 0,
  once = true
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { amount: 0.25, once });

  return (
    <motion.div
      ref={ref}
      className={className}
      initial={{ opacity: 0, y, x, filter: 'blur(8px)' }}
      animate={isInView ? { opacity: 1, y: 0, x: 0, filter: 'blur(0px)' } : {}}
      transition={{ duration, delay, ease: [0.22, 0.61, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
};

export default Reveal;
